import api from "api/api";

export const createMissionBackupQuery = async ({ data }) =>
  await api.post(`/mission-backup`, data);

export const getMissionIsBackupableByIdQuery = async ({ id }) =>
  await api.get(`/mission-backup/${id}/is-backupable`);
